<template>
  <div class="nx-video-rendition-set-list">
    <nx-relation-editor-toolbar :title="title" />
    <nx-list :items="formattedItems" @click:item="handleClick" normal selectable>
        <template #item-actions="{ item }">
          <nx-video-rendition-download :url="item.url" />
          <v-tooltip top>
            <template #activator="{on}">
              <v-btn v-on="on" @click="copyUrlToClipboard(item.url)" :href="item.url" class="ma-0" icon flat>
                <v-icon color="primary" class="theme--light">link</v-icon>
              </v-btn>
            </template>
            <strong v-html="$t('message.list.actions.copyUrlToClipboard')"></strong>
          </v-tooltip>
        </template>
    </nx-list>
    <nx-dialog @input="previewItem = null"
               :value="previewItem !== null"
               icon="smart_display"
               :persistent="false"
               :title="previewItem ? previewItem.title : null"
               max-width="80vw">
      <video v-if="previewItem" width="100%" autoplay controls :src="previewItem.url"/>
    </nx-dialog>
  </div>
</template>

<script>
import NxRelationEditorToolbar from '@/modules/relation/editor/components/Toolbar';
import NxList from '@/components/list/List';
import NxVideoRenditionDownload from '@/modules/video/components/VideoRenditionDownload';
import NxDialog from '@/components/dialogs/Dialog';
import { copyToClipboard } from '@/utils';

export default {
  name: 'nx-video-rendition-set-list',
  components: {
    NxDialog,
    NxVideoRenditionDownload,
    NxList,
    NxRelationEditorToolbar,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
    },
    value: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      previewItem: null,
      downloadingVideo: false,
    };
  },
  computed: {
    title() {
      if (this.label) {
        return this.label;
      }
      return this.$t(`message.form.fields.${this.name}`);
    },
    formattedItems() {
      return this.value.map(item => ({
        id: item.id,
        image: this.getImage(item),
        title: item.description,
        chips: this.getChips(item),
        url: item.url,
        icon: this.getIcon(item),
      }));
    },
  },
  methods: {
    getImage(item) {
      if (!item.thumbnail) {
        return null;
      }
      return {
        src: item.thumbnail,
      };
    },
    getIcon(item) {
      if (!item.icon) {
        return null;
      }
      return {
        name: item.icon,
      };
    },
    getChips(item) {
      const chips = [];
      if (item.resolution) {
        chips.push({
          value: item.resolution,
          tooltip: 'metadata.resolution',
        });
      }
      if (item.size) {
        chips.push({
          value: item.size,
          tooltip: 'metadata.size',
        });
      }
      if (item.length) {
        chips.push({
          value: item.length,
          tooltip: 'metadata.videoLength',
        });
      }
      return chips;
    },
    handleClick(item) {
      this.previewItem = item;
    },
    async copyUrlToClipboard(url) {
      await copyToClipboard(url);
      this.toast.notify('message.list.actions.clipboardCopy');
    },
  },
};
</script>

<style lang="stylus">
@import '../../../assets/stylus/variables.styl'

.nx-video-rendition-set-list {
  .nx-list .nx-list-item .text--item-title {
    color: $black;
  }
}
</style>
